import React from "react";
import { useClerk } from "@clerk/react";
import '../../Styles/LandingPage.scss'

const LogoutButton = () => {
  const { signOut } = useClerk();

  const returnUrl = process.env.REACT_APP_REDIRECT_LOGOUT;

  const handleLogOut = () => {
    // Clear your existing localStorage items (keep these as is)
    localStorage.removeItem("userRentEasy")
    localStorage.removeItem("agentProfilePic")
    localStorage.removeItem("AgentId_Entered")

    // Clerk sign out with redirect
    signOut({ redirectUrl: returnUrl })
  }

  return (
    <button className="btn style-btn" onClick={handleLogOut}>
      Log Out
    </button>
  );
};

export default LogoutButton;